import gql from 'graphql-tag';

import { IHistoricalOrder } from '@rbi-ctg/menu';
import { OrderStatus } from 'state/order';

import { UserOrderFragment } from './fragments/user-order';

export interface IGetUserOrders {
  userOrders: {
    count: number;
    orders: IHistoricalOrder[];
  };
}

export interface IGetUserOrdersInput {
  orderStatuses: OrderStatus[];
  limit?: number;
  userId?: string | null;
  shouldFilterByRegion?: boolean;
  createdAfter?: string;
}

export const GetUserOrdersQuery = gql`
  query GetUserOrders(
    $userId: ID
    $limit: Int
    $orderStatuses: [RbiOrderStatus!]
    $shouldFilterByRegion: Boolean
    $createdAfter: String
  ) @authRequired {
    userOrders(
      userId: $userId
      limit: $limit
      orderStatuses: $orderStatuses
      shouldFilterByRegion: $shouldFilterByRegion
      createdAfter: $createdAfter
    ) {
      count
      orders {
        ...UserOrderFragment
      }
    }
  }

  ${UserOrderFragment}
`;

export interface IGetUserOrder {
  order: IHistoricalOrder;
}

export interface IGetUserOrderInput {
  id: string;
}

export const GetUserOrderQuery = gql`
  query GetUserOrder($id: ID!) @authRequired {
    order(rbiOrderId: $id) {
      ...UserOrderFragment
    }
  }

  ${UserOrderFragment}
`;

export default GetUserOrdersQuery;
